<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader class="object-header">
                                <CRow>
                                    <CCol>
                                        <ButtonBack
                                            class="mr-3"
                                            title="Go back"
                                        />
                                    </CCol>
                                    <CCol class="d-flex justify-content-end">
                                        <TableSettings
                                            :allFields="
                                                tables.integrationLogs.allFields
                                            "
                                            :activeFields.sync="
                                                tables.integrationLogs.fields
                                            "
                                        />
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.integrationLogs.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.integrationLogs
                                                .fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :itemsPerPageSelect="{
                                        values: [5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="
                                        tables.integrationLogs.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="
                                        tables.integrationLogs.rows
                                    "
                                    v-bind="tables.integrationLogs"
                                >
                                </CDataTable>
                                <div class="d-flex justify-content-end mt-3">
                                    <ButtonExport
                                        :endPoint="
                                            '/provider-integrations/' +
                                            uuid +
                                            '/logs'
                                        "
                                        :table="tables.integrationLogs"
                                    />
                                    <div class="ml-3">
                                        <button
                                            class="m-2 p-0 btn-export-table"
                                            @click="exportItemsWithError()"
                                        >
                                            <span class="block-icon">
                                                <CIcon
                                                    :content="
                                                        $options.icons
                                                            .cilDataTransferDown
                                                    "
                                                />
                                            </span>
                                            <span class="text">
                                                {{
                                                    $t(
                                                        "Export items with error"
                                                    )
                                                }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.integrationLogs.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="
                                            tables.integrationLogs.page
                                        "
                                        :pages="
                                            tables.integrationLogs.total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.integrationLogs.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import ButtonCreate from "~/components/ButtonCreate";
import FilterDate from "~/components/FilterDate";
import ButtonBack from "£lement/ButtonBack";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import { exportCSVFile, adapterTableItemsFromHeaders } from "~/helpers/table";
/** Others */
import {
    cilPlus,
    cilSettings,
    cilBullhorn,
    cilDataTransferDown,
} from "@coreui/icons";
import IntegrationLogsTable from "./config/tables/integration_logs";
export default {
    name: "InputsIntegrationsMainPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        ButtonCreate,
        ButtonBack,
        FilterDate,
        TableSettings,
        ButtonExport,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilBullhorn,
        cilDataTransferDown,
    },
    data() {
        return {
            tables: {
                integrationLogs: IntegrationLogsTable,
            },
        };
    },
    computed: {
        uuid() {
            return this.$route.params.uuid;
        },
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.integrationLogs.rows = newValue;
            this.updatePagination(this.tables.integrationLogs.page);
        },
        updatePagination(newValue) {
            this.tables.integrationLogs.page = newValue;
            this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "integrationLogs",
                url: `/provider-integrations/${this.uuid}/logs`,
            });
            this.tables.integrationLogs.loading = false;
            this.updatePageLoading(false);
        },
        async exportItemsWithError() {
            let method = "GET";
            let url = "/provider-integrations/" + this.uuid + "/logs/error";

            let adapterFiltersFunction = (filters) => {
                return filters;
            };
            let tableFilter = this.createQuery({
                where: {
                    ["created_at"]: {
                        between: [this.storeFrom, this.storeTo, false],
                    },
                },
            });
            tableFilter = adapterFiltersFunction(tableFilter);

            try {
                let items = await this.fetcher({
                    url,
                    method,
                    query: {
                        query: tableFilter,
                    },
                });

                var data = [];
                var headers = {};
                let keys = [];
                Object.values(items["_items"]).forEach((value, index) => {
                    data.push(value);
                    keys = Object.keys(value);
                    keys.forEach((element) => {
                        if (!parseInt(element) && parseInt(element) != 0) {
                            if (!headers.hasOwnProperty(element)) {
                                headers[element] = element;
                            }
                        }
                    });
                });

                await exportCSVFile({
                    headers,
                    items: adapterTableItemsFromHeaders(data, headers),
                    fileName: "itemsWithError",
                });
            } catch (error) {
                this.showMessageError(error);
            }
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
